import { useState } from 'react';
import {
  InputLabel,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Tooltip,
  Box,
} from '@mui/material';
import { jids } from '../../../../../data/forms/generalDropdownOptions.js';
import {
  incorrectStatusOptions,
  actionTakenOptions,
} from '../../../../../data/forms/fst/incorrectCaseDropdownOptions.js';
import axios from 'axios';

const IncorrectCaseForm = ({
  translations,
  user,
  handleFormSelectionReset,
  setSnackbarMessage,
  setIsSnackbarOpen,
  setSnackbarSeverity,
}) => {
  const [form, setForm] = useState({
    jurisdiction: '',
    incorrectStatus: '',
    actionTaken: '',
    email: user.email,
    emailAddress: user.email,
    userId: user.userId,
    displayName: user.displayName,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleClear = () => {
    setForm({
      ...form,
      jurisdiction: '',
      incorrectStatus: '',
      actionTaken: '',
    });
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await axios({
        url: `${process.env.REACT_APP_ENDPOINT_INCORRECT_CASE_FORM}`,
        data: {
          ...form,
        },
      });
      setSnackbarMessage('Form submitted successfully!');
      setSnackbarSeverity('success');
      setIsSnackbarOpen(true);
      setIsSubmitting(false);
      handleClear();
      handleFormSelectionReset();
    } catch (error) {
      console.error('Error submitting form:', error);
      setSnackbarMessage(
        'There was an error submitting the form. Please try again. If the problem persists, contact support.'
      );
      setSnackbarSeverity('error');
      setIsSnackbarOpen(true);
      setIsSubmitting(false);
    }
  };

  const isFormValid = () => {
    const { jurisdiction, incorrectStatus, actionTaken } = form;

    if (!jurisdiction || !incorrectStatus || !actionTaken) {
      return false;
    }

    return true;
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: 'flex',
        justifyItems: 'center',
        width: { xs: 'auto', md: 'var(--forms-layout-width, 90vw)' },
      }}
    >
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControl
          required
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>
            {translations.jurisdiction || 'Select Form Type'}
          </InputLabel>
          <Select
            value={form.jurisdiction}
            label={translations.jurisdiction || 'Select Form Type'}
            onChange={handleChange}
            name='jurisdiction'
          >
            {jids.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          required
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Action Taken'}</InputLabel>
          <Select
            value={form.actionTaken}
            label={'Action Taken'}
            onChange={handleChange}
            name='actionTaken'
          >
            {actionTakenOptions.map(option => (
              <MenuItem value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControl
          required
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Incorrect Status'}</InputLabel>
          <Select
            value={form.incorrectStatus}
            label={'Incorrect Status'}
            onChange={handleChange}
            name='incorrectStatus'
          >
            {incorrectStatusOptions.map(option => (
              <MenuItem value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label='Associate Name'
          disabled
          value={`${user.firstName} ${user.lastName}`}
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        />
      </Grid>
      <Grid
        size={12}
        sx={{
          marginTop: '20px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button
          variant='contained'
          sx={{
            backgroundColor: 'var(--aldebaran-yellow)',
            color: '#000000',
            fontFamily: 'BrightstarSans-Regular',
            width: '10%',
          }}
          onClick={handleClear}
        >
          Clear
        </Button>
        <Tooltip
          title={
            !isFormValid()
              ? 'Please fill in all required fields to enable the Submit button'
              : ''
          }
          arrow
        >
          <Box>
            <Button
              disabled={!isFormValid() || isSubmitting}
              variant='contained'
              sx={{
                backgroundColor: 'var(--vega-blue)',
                fontFamily: 'BrightstarSans-Regular',
                width: '100%',
              }}
              onClick={handleSubmit}
              loading={isSubmitting}
            >
              {'Submit'}
            </Button>
          </Box>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default IncorrectCaseForm;
